<template>
	<div>
		<hr/>
		
		<h2>Pre-Contratos</h2>
		<br>
		<input type="text" id='busca' align="center" v-model='abuscar'> Buscar
		<br>
		<br>

		<ul id='contratos-lista' v-if="contratosTodos !=null" align="left">
			<li v-for="contra in buscando" v-if='esProformaOcontrato == contra.status' >	

				<div v-if='esProformaOcontrato == contra.status' v-on:click="lanza(contra.inquilinoId, contra.propiedadId, contra.inquilino, contra.propiedad, contra.giro, contra.familia, contra.subfamilia, contra.dueno, contra.emailInquilino, contra.importeMes, contra.celularInquilino, contra.fbInquilino, contra.dirInquilino, contra.wappInquilino, contra.fechaInicio, contra.fechaTerminacion, contra.idInquilino, contra.comDomInquilino, contra.nombreAval, contra.direccionAval, contra.celularAval, contra.mailAval, contra.fbAval, contra.nombreComercial, contra.medidasYcol, contra.area)">

					<strong>
					    Contrato Num.  {{contra.id}} <br>
  						{{contra.inquilino}} <br>
  						{{contra.propiedad}}<br>
  						<font color="orange">{{contra.giro}}<br>
					    {{contra.nombreComercial}} </font><br>
					    {{contra.familia}} <br>
					    {{contra.subfamilia}} <br>
              {{contra.status}} <br>
              <p>Termina: {{formateaFecha(contra.fechaTerminacion)}}</p>
              <p><font color="red">{{vencido(contra.fechaTerminacion, contra.status)}}</font></p>
					</strong>

					<br>

					<button type='button' v-on:click="lanza(contra.inquilinoId, contra.propiedadId, contra.inquilino, contra.propiedad, contra.giro, contra.familia, contra.subfamilia, contra.dueno, contra.emailInquilino, contra.importeMes, contra.celularInquilino, contra.fbInquilino, contra.dirInquilino, contra.wappInquilino, contra.fechaInicio, contra.fechaTerminacion, contra.idInquilino, contra.comDomInquilino, contra.nombreAval, contra.direccionAval, contra.celularAval, contra.mailAval, contra.fbAval, contra.nombreComercial, contra.medidasYcol, contra.area)" class="button is-primary is-rounded"> Seleccionar
					</button>
				</div>
  		</li>
		</ul>
		<span v-else>Cargando contratos ...</span>
	</div>
</template>


<script>
import axios from 'axios';

export default {
  name: 'PreContratos-buscar',
  mounted(){
  	this.getContratos();
  },
  props: ['esProformaOcontrato'],  
  data () {
    return {
      contratosTodos: null,
      abuscar:''
    }
  },
  methods:{	
  	lanza: function(inId, prId, inq, pr, gir, fam, subfam, dueno, elmail, renta, celularInquilino, fbInquilino, dirInquilino, wappInquilino, fechaInicio, fechaTerminacion, idInquilino, comDomInquilino, nombreAval, direccionAval, celularAval, mailAval, fbAval,  nomComercial, medidasYcol, area){
	    	this.$emit('eventoProf', inId, prId, inq, pr, gir, fam, subfam, dueno, elmail, renta, celularInquilino, fbInquilino, dirInquilino, wappInquilino, fechaInicio, fechaTerminacion, idInquilino, comDomInquilino, nombreAval, direccionAval, celularAval, mailAval, fbAval, nomComercial, medidasYcol, area );
  	},
  	getContratos(){
  		axios.get('https://www.directodo.com/Rentus/accesosdb/leeContratos.php')
  		     .then((respuesta) => {
  		     	this.contratosTodos = respuesta.data;
  			 });

  	},

    vencido: function(fecha, status){
      var fecha1 = new Date(fecha); 
      fecha1.setHours(0); 

      var hoy = new Date(); 
      hoy.setHours(0);

      var fechams = fecha1.getTime(); // en milisegundos        
      var hoyms = hoy.getTime(); // en milisegundos

      if(fechams < hoyms){
        if(status == "FINALIZADO"){
          return ".";
        }
        return "Contrato Vencido";
      } else return ".";

    },

    formateaFecha: function (fecha) {
        var d = new Date(fecha); 
        if (Date.parse(d)){
          // pone los minutos de la zona horaria local. Si no lo haces le agrega un dia a la fecha
          d.setMinutes(d.getMinutes() + d.getTimezoneOffset());
          d.setHours(0);
          var opciones = { year: 'numeric', month: 'short', day: 'numeric' };
          d = new Intl.DateTimeFormat('es-mx', opciones).format(d);
          return d} 
        else{return "sin fecha";}
      }

  },
  computed:{
  	buscando: function () {
  		return this.contratosTodos.filter((item) => 
  				   item.giro.toUpperCase().includes(this.abuscar.toUpperCase()) 
  				|| item.inquilino.toUpperCase().includes(this.abuscar.toUpperCase()) 
  				|| item.propiedad.toUpperCase().includes(this.abuscar.toUpperCase()) 
  				|| item.familia.toUpperCase().includes(this.abuscar.toUpperCase()) 
  				|| item.subfamilia.toUpperCase().includes(this.abuscar.toUpperCase()) 
  				|| item.nombreComercial.toUpperCase().includes(this.abuscar.toUpperCase()) );

  	}
  }
}

</script>

<style lang="scss">

</style>




// WEBPACK FOOTER //
// src/Pre-o-Contratos-buscar.vue